export default function adminAuth({ next, store }) {
    if (!store.isLoggedIn) {
        return next({ path: '/login' });
    }

    if (store?.role === 'user') {
        return next({ name: 'Dashboard' });
    }

    if (store?.role !== 'admin') {
        return next({ name: 'Unauthorized' });
    }

    return next();
}